<template>
  <li class="nav-item" v-if="items > 0">
    <a class="navigation-link item logged mr-2 no-underline" href="/products?tab=review">
      <span class="link-text">Review</span>
      <span class="numb">{{items}}</span>
    </a>
  </li>
</template>

<script>
export default {
  data() {
    return {
      items: 0,
      loading: false,
    };
  },

  created() {
    this.getItems();
  },

  methods: {

    getItems() {

      this.loading = true;

      axios
        .get('/in-review')
        .then((response) => {
          this.items = response.data;
          this.loading = false;
        });

    },

  },
};
</script>
